import React, { useState, useEffect } from "react";
import { css } from "emotion";
import { stepContent, header, singleInput, loadingStyle } from "./../style";
import InputForm from "../../../../../shared/atoms/InputForm";

import { patternOnlyNumbers } from "../../../../../shared/create-offer/utils/masks";

import { useNewOfferMobile } from "../../context";
import { returnUserJWT } from "../../../../shared/utils";
import { useNewOffer } from "../../../../context/new-offer";
import Loading from "../../../../../shared/create-offer/Loading/Loading";
import InfoFidelityStep from "./infosSeeMore/InfoFidelityStep"

const UserAccess = ({ onChangeLoyalty }) => {
	const { currentProgram: fidelityProgram, loyaltyData, userData, rankingData } = useNewOffer();
	const { setStepError } = useNewOfferMobile();

	const [state, setState] = useState({
		user: loyaltyData.data.user || loyaltyData.data.username || "",
		hasError: false
	});

	useEffect(() => {
		const cpf = returnUserJWT().ssn;
		const user = loyaltyData.data.user || loyaltyData.data.username;
		const hasError = user !== undefined && (!user.length || user === cpf);

		setState({
			...state,
			user,
			hasError
		});
		setStepError(!user || hasError);
	}, [loyaltyData.data]);

	const onChange = ev => {
		let user = ev.target.value;
		const cpf = returnUserJWT()
			.ssn.match(patternOnlyNumbers)
			.join("")
			.toString();

		setState({ ...state, user, hasError: !user.length || user === cpf });
		onChangeLoyalty({ user, username: user });
	};

	if (userData.isFetching || rankingData.isFetching) {
		return (
			<div
				className={css`
					${loadingStyle};
				`}
			>
				<Loading width={120} height={120} />
			</div>
		);
	}

	return (
		<div
			className={css`
				${stepContent};
			`}
		>
			<strong
				className={css`
					${header};
				`}
			>
				Dados da {fidelityProgram.fidelityName}
			</strong>
			<div
				className={css`
					${singleInput};
				`}
			>
				<InputForm
					name="user"
					id="user"
					value={state.user}
					onChange={onChange}
					placeholder=""
					label="Usuário"
					hasError={state.hasError}
					errorMessage="Nas companhias internacionais, o cadastro do usuário é diferente do número do CPF."
				/>
			</div>
			<InfoFidelityStep
				fidelityId={fidelityProgram.id}
				acronym={fidelityProgram.fidelityName}
			/>
		</div>
	);
};

export default UserAccess;
